import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';
import GlobalButtonWrapper from './GlobalButtonWrapper';
function SecondaryButton({ children, ...props }: ButtonProps) {
  return (
    <GlobalButtonWrapper props={props}>
      <Button variant="outlined" color="primary" {...props}>
        {children}
      </Button>
    </GlobalButtonWrapper>
  );
}

export default SecondaryButton;
